import React, { useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { apiCall, getBaseDir, float2moeda, userHasRole } from '../../../utils.js';
import ReportFilter from '../../../components/report/ReportFilter.js';
import TableBuilder from '../../../table_builder.js';
const XLSX = require('xlsx');

const ManagerReports = () => {
    const exportToExcel = () => {
        let formData = window.exportData;
        formData.export = true;

        // Acquire Data (reference to the HTML table)
        var table_elt = document.getElementById("table-manager-reports-list");

        // Extract Data (create a workbook object from the table)
        var workbook = XLSX.utils.table_to_book(table_elt);

        // Process Data (add a new row)
        var ws = workbook.Sheets["Sheet1"];
        XLSX.utils.sheet_add_aoa(ws, [["Emitido em "+new Date().toISOString()]], {origin:-1});

        // Package and Release Data (`writeFile` tries to write and save an XLSB file)
        XLSX.writeFile(workbook, 'relatorio_gerencia_comissoes_'+window.getSaoPauloDateTime()+'.xlsx');
    }

    const exportJsPdf = () => {
        const { jsPDF } = window.jspdf;
        // Create a new jsPDF instance with landscape orientation
        const doc = new jsPDF('landscape');

        // Base64 encoded image string (you can convert your image to Base64)
        const imgData = 'data:image/png;base64,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'; // Replace this with your Base64 image string

        // Convert Base64 to image
        const logo = new Image();
        logo.src = imgData;
        logo.onload = function() {
            const logoWidth = 25; // Adjust logo width as needed
            const logoHeight = (logo.height * logoWidth) / logo.width;

            // Add logo to PDF
            doc.addImage(logo, 'PNG', 5, 5, logoWidth, logoHeight);

            // Add title
            doc.setFontSize(14);
            // Get the width of the PDF page
            const pageWidth = doc.internal.pageSize.getWidth();

            var reportType = "quiropraxista";
            switch(window.reportType) {
                case 'REPORTS_COMMISSION': {
                    reportType = "doutor";
                    break;
                }
                case 'REPORTS_COMMISSION_ATTENDANT': {
                    reportType = "atendente";
                    break;
                }
                case 'REPORTS_COMMISSION_DIRECTOR': {
                    reportType = "diretoria";
                    break;
                }
            }

            var titleText = "Relatório de Comissões Cortesia (Atendimento c/Valor Zerado) - "+reportType;
            // Get the width of the text to center it
            var textWidth = doc.getTextWidth(titleText);
            // Calculate the X coordinate to center the text
            var textX = (pageWidth - textWidth) / 2;

            // Add title at the top and centered
            doc.text(titleText, textX, 10);

            titleText = `Relatório gerado em ${window.getSaoPauloDateTime()}`;
            // Get the width of the text to center it
            textWidth = doc.getTextWidth(titleText);
            // Calculate the X coordinate to center the text
            textX = (pageWidth - textWidth) / 2;    
            // Add title at the top and centered
            doc.text(titleText, textX, 15);

            titleText = `Período: ${moment(window.startDate).format('DD/MM/YYYY')} ${window.endDate !== '' ? `até ${moment(window.endDate).format('DD/MM/YYYY')}` : ''}`;
            // Get the width of the text to center it
            textWidth = doc.getTextWidth(titleText);
            // Calculate the X coordinate to center the text
            textX = (pageWidth - textWidth) / 2;
            // Add title at the top and centered
            doc.text(titleText, textX, 20);

            let columnStyles = {};
            if (window.reportType === 'REPORTS_COMMISSION') {
                columnStyles = {
                0: { cellWidth: 20 }, // Doutor
                1: { cellWidth: 80 }, // Cliente
                2: { cellWidth: 15 },  // Tipo
                3: { cellWidth: 50 },  // Serviço
                4: { cellWidth: 25 },  // Contrato + parcela
                5: { cellWidth: 8 },  // Fechou
                6: { cellWidth: 20 },  // Vlr Contrato
                7: { cellWidth: 15 },  // Valor
                8: { cellWidth: 10 },  // Comissao %
                9: { cellWidth: 20 },  // Vlr. Comissao
                10: { cellWidth: 25 }  // Atendimento
                }
            }
            if (window.reportType === 'REPORTS_COMMISSION_ATTENDANT') {
                columnStyles = {
                0: { cellWidth: 20 }, // Categoria
                1: { cellWidth: 20 }, // Doutor
                2: { cellWidth: 80 }, // Cliente
                3: { cellWidth: 15 },  // Tipo
                4: { cellWidth: 50 },  // Serviço
                5: { cellWidth: 25 },  // Contrato + parcela
                6: { cellWidth: 8 },  // Fechou
                7: { cellWidth: 20 },  // Vlr Contrato
                8: { cellWidth: 15 },  // Valor
                9: { cellWidth: 25 }  // Atendimento
                }
            }

            // Extract table and add to PDF
            doc.autoTable({
                html: '#table-manager-reports-list',
                startY: 25,
                theme: 'grid',
                styles: { 
                    fontSize: 9, // Decrease font size to fit more content
                    cellPadding: 1
                },
                headStyles: {
                    fillColor: [255, 0, 0]
                },
                alternateRowStyles: {
                    fillColor: [240, 240, 240]
                },
                columnStyles: columnStyles,
                margin: { top: 1, right: 1, bottom: 1, left: 1 },
                scale: 0.8 // Scale content to fit the page
            });

            // extract resume table 
            doc.autoTable({
                html: '#table-manager-reports-list-resume',
                startY: doc.autoTable.previous.finalY + 10,
                theme: 'grid',
                styles: { 
                fontSize: 9, // Decrease font size to fit more content
                cellPadding: 1
                },
                headStyles: {
                fillColor: [255, 0, 0]
                },
                alternateRowStyles: {
                fillColor: [240, 240, 240]
                },
            });

            // Add a title to the PDF
            //doc.text("My Custom Table in Landscape", 14, 15);

            // Save the PDF
            doc.save('relatorio_doutor_comissoes_cortesia_'+window.getSaoPauloDateTime()+'_'+reportType+'.pdf');
        }
    }

    // add event listeners
    window.exportToExcel = exportToExcel;
    window.exportJsPdf = exportJsPdf;

    return (
        <>test</>
    );
}

try {
    if (document.getElementById('js-chiro-courtesies-root')) {
      const container = document.getElementById('js-chiro-courtesies-root');
      const root = createRoot(container); // createRoot(container!) if you use TypeScript
      root.render(<ManagerReports />);
    }
  } catch(err) {
    console.error('ManagerReports error', err);
  }